<template>
    <div>
        <table-actions-menu
            position="table-action-menu--low"
            width="table-action-menu--only-one">
            <async-table-action-button :callback="changeTenant" :noPremadeMode="true" grid="table-action-cell--grid-1of1">
                <div class="table-action-cell__icon-wrapper">
                    <inline-svg
                        :url="require('../../../../images/actions/icon-move.svg')"
                        classes="table-action-cell__icon"
                    >
                    </inline-svg>
                </div>
                <div class="table-action-cell__label">{{ trans('global_search.actions.go_there') }}</div>
            </async-table-action-button>
        </table-actions-menu>
    </div>
</template>

<script>
    import InlineSvg from '../../../util/inlineSvg.js'
    import EditButton from '../../table_actions/table_actions_buttons/EditButton.vue';
    import DeleteButton from '../../table_actions/table_actions_buttons/DeleteButton.vue';

    export default {
        props: ['data', 'index', 'url'],

        components: {
            EditButton,
            DeleteButton,
            InlineSvg
        },

        methods: {
            changeTenant() {
                localStorage.setItem('query', this.data.name);

                axios.post('/api/change-tenant', {'ident': this.data.tenant_ident})
                .then(() => {
                    window.location = this.url;
                });
            },
        }
    }
</script>
